// Cloudflare Turnstile site key (PUBLIC — safe to commit)
export const TURNSTILE_SITE_KEY =
  (import.meta.env.VITE_TURNSTILE_SITE_KEY as string | undefined) ||
  "0x4AAAAAADmaTvDoQ2guyWZS";
